import { motion } from "framer-motion";

const TEXTS = [
  {
    numeral: "I",
    title: "The Emerald Tablet",
    latin: "Tabula Smaragdina",
    quote:
      "That which is Below corresponds to that which is Above, and that which is Above corresponds to that which is Below, to accomplish the miracles of the One Thing.",
    origin: "Hermes Trismegistus · c. 8th Century",
  },
  {
    numeral: "II",
    title: "The Key of Solomon",
    latin: "Clavicula Salomonis",
    quote:
      "He who desireth to perform magical operations must understand the secret power of planetary hours and sacred seals engraved under auspicious celestial aspects.",
    origin: "Solomonic Grimoire Tradition",
  },
  {
    numeral: "III",
    title: "The Picatrix",
    latin: "Ghayat al-Hakim",
    quote:
      "Magic is a spirit in action, linking the celestial virtues with terrestrial matter to bring forth that which is desired in accordance with the stars.",
    origin: "Arabian Astrological Magic · c. 10th Century",
  },
  {
    numeral: "IV",
    title: "Folk Lore & Earth Magic",
    latin: "Canon of the Hearth",
    quote:
      "Use every form of ancient knowledge so as to attract every people — for truth knows no border, and the elements obey those who speak with reverence.",
    origin: "Traditional Folk Magick Canon",
  },
];

export const Grimoires = () => (
  <section
    id="grimoires"
    data-testid="grimoires-section"
    className="relative py-28 sm:py-36 bg-ink2 border-y border-gold/10"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 md:flex items-end justify-between"
      >
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-gold/80 font-mono mb-4">
            From the Old Texts
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-parchment max-w-xl">
            Writings that have guided practitioners for a thousand years
          </h2>
        </div>
        <p className="mt-6 md:mt-0 max-w-sm text-sm text-parchment-muted leading-relaxed">
          Every rite we perform is rooted in a verifiable lineage of hermetic,
          Solomonic, Picatrician and folk tradition — never invented, always inherited.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {TEXTS.map((t, i) => (
          <motion.blockquote
            key={t.title}
            data-testid={`grimoire-card-${t.numeral.toLowerCase()}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.15 }}
            className="parchment-card relative rounded-xl p-9 sm:p-11 card-glow transition-shadow duration-500"
          >
            <span className="absolute top-6 right-8 font-display text-4xl text-gold/20">
              {t.numeral}
            </span>
            <p className="text-[10px] uppercase tracking-[0.35em] font-mono text-gold/70 mb-2">
              {t.latin}
            </p>
            <h3 className="font-serif text-xl sm:text-2xl text-gold mb-6">{t.title}</h3>
            <p className="font-quote italic text-lg sm:text-xl text-parchment/90 leading-relaxed mb-8">
              “{t.quote}”
            </p>
            <footer className="text-xs uppercase tracking-[0.2em] text-parchment-muted">
              — {t.origin}
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
